<template>
  <div>
    <div class="proImg">
      <img :src="imageUrl" alt="" srcset="" class="proIm" />
    </div>
    <div id="video-1" class="p-title">公司宣传片</div>
    <div class="video-type">产品介绍片</div>
    <div class="product-video">
      <img src="@/assets/video-title.png" width="1060.76" />
      <img
        :src="productDataUrl"
        @click="player(productData[0])"
        width="1059.31"
        height="100%"
        style="
          cursor: pointer;
          border-radius: 8px;
          margin-top: -5px;
          border-top-left-radius: 0;
          border-top-right-radius: 0;
        "
      />
      <img
        src="@/assets/play-icon.png"
        class="play-icon"
        @click="player(productData[0])"
      />
    </div>
    <div class="video-type" style="margin-top: 54px">招商宣传片</div>
    <div class="promotional-video">
      <img src="@/assets/video-title.png" width="1060.76" />
      <img
        :src="investDataUrl"
        @click="player(investData[0])"
        width="1059.31"
        height="100%"
        style="
          cursor: pointer;
          border-radius: 8px;
          margin-top: -5px;
          border-top-left-radius: 0;
          border-top-right-radius: 0;
        "
      />
      <img
        src="@/assets/play-icon.png"
        class="play-icon"
        @click="player(investData[0])"
      />
    </div>
    <div id="video-2" class="p-title">专题记录片</div>
    <div class="record-video">
      <div
        class="video-item"
        v-for="(item, index) in recordData.slice(0, 2)"
        :key="index"
        @click="player(item)"
      >
        <div class="video">
          <img src="@/assets/record-video.png" />
          <img :src="item.coverUrl" class="video-cover" />
        </div>
        <div class="video-title">{{ item.title }}</div>
        <div class="video-num">浏览量：{{ item.viewCount }}</div>
      </div>
    </div>
    <div class="flexbox">
      <div id="video-3" class="f-title">小视频分享</div>
      <div class="f-more" @click="toMoreVideo">
        更多视频<i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <div class="small-video">
      <div
        class="video-item"
        v-for="(item, index) in smallVideo.slice(0, 4)"
        :key="index"
        @click="player(item)"
      >
        <div class="video">
          <img :src="item.coverUrl" class="video-cover" />
        </div>
        <div class="video-title">{{ item.title }}</div>
        <div class="video-num">浏览量：{{ item.viewCount }}</div>
        <div class="line"></div>
        <div class="item-footer">
          <div>知孝云谱</div>
          <div>{{ item.updateTime.substr(0, 10) }}</div>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      width="70%"
      @close="closeDia"
      top="10vh"
    >
      <video
        v-if="playUrl"
        ref="video"
        class="videoDoms"
        :src="playUrl"
        :autoplay="autoplay"
        controls
      ></video>
    </el-dialog>
  </div>
</template>

<script>
import { getWebsite } from "@/api/request";
import * as url from "url";
import { getNewsDatebyId } from "../../api/request";
export default {
  name: "videos",
  computed: {
    url() {
      return url;
    },
  },
  components: {},
  data() {
    return {
      imageUrl: "",
      productData: [],
      investData: [],
      recordData: [],
      smallVideo: [],
      dialogVisible: false,
      playUrl: "",
      autoplay: true,
      productDataUrl: "",
      investDataUrl: "",
    };
  },
  created() {
    this.getWebsites();
    this.getVideos();
  },
  mounted() {},
  methods: {
    getWebsites() {
      getWebsite({
        type: 3,
        isOut: true,
        secondType: 11,
      }).then((res) => {
        // this.imageUrl = res.result?.records[0]?.coverUrl
        if (
          res.data &&
          res.data.result &&
          res.data.result.records &&
          res.data.result.records &&
          res.data.result.records[0] &&
          res.data.result.records[0].coverUrl
        ) {
          this.imageUrl = res.data.result.records[0].coverUrl;
        }
      });
    },
    getVideos() {
      getWebsite({
        type: 2,
        isOut: true,
      }).then((res) => {
        if (
          res.data &&
          res.data.result &&
          res.data.result.records &&
          res.data.result.records
        ) {
          // this.coverUrl = res.data.result.records[0].coverUrl
          // this.videoUrl = res.data.result.records[0].videoUrl
          let data = res.data.result.records;
          this.productData = data.filter((item) => item.secondType == 4);
          this.investData = data.filter((item) => item.secondType == 5);
          this.recordData = data.filter((item) => item.secondType == 6);
          this.smallVideo = data.filter((item) => item.secondType == 7);
          this.productDataUrl =
            this.productData.length > 0 ? this.productData[0].coverUrl : "";
          this.investDataUrl =
            this.investData.length > 0 ? this.investData[0].coverUrl : "";
        }
      });
    },
    player(item) {
      this.dialogVisible = true;
      this.playUrl = item.videoUrl;
      getNewsDatebyId(item.id).then((res) => {});
      this.$nextTick(() => {
        this.$refs.video.play();
      });
      this.autoplay = true;
    },
    toMoreVideo() {
      this.$router.push({
        path: "/moreVideo",
      });
    },
    closeDia() {
      this.$nextTick(() => {
        this.$refs.video.pause();
      });
      this.autoplay = false;
    },
  },
};
</script>
<style lang="scss">
.el-dialog__wrapper {
  text-align: center;
  white-space: nowrap;
  overflow: auto;
}
.el-dialog__wrapper :after {
}
.el-dialog {
  display: inline-block;
  vertical-align: middle;
  text-align: center;
  white-space: normal;
}
.el-dialog__body {
  padding: 0;
}
</style>
<style  scoped>
.videoDoms {
  width: 100%;
  height: 600px;
  padding: 30px 0;
}
.proImg {
  height: 600px;
}
.proIm {
  width: 100%;
  height: 100%;
}
.p-title {
  font-size: 32px;
  font-weight: 700;
  color: #111111;
  margin-top: 100px;
  margin-bottom: 50px;
}
.video-type {
  font-size: 24px;
  font-weight: 400;
  color: #666;
  margin-bottom: 28px;
}
.product-video {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.play-icon {
  width: 96px;
  height: 96px;
}
.product-video > .play-icon {
  position: absolute;
  top: 50%;
  left: 48%;
  cursor: pointer;
}
.promotional-video {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.promotional-video > .play-icon {
  position: absolute;
  top: 50%;
  left: 48%;
  cursor: pointer;
}
.record-video {
  display: flex;
  justify-content: center;
}
.record-video > .video-item {
  width: 681px;
  position: relative;
  text-align: left;
  border: 1px solid #eaeff5;
  cursor: pointer;
}
.record-video > .video-item:last-child {
  margin-left: 39px;
}
.record-video > .video-item > .video > .video-cover {
  position: absolute;
  top: 110px;
  left: 134px;
  height: 255px;
  width: 408px;
}
.small-video {
  display: flex;
  justify-content: center;
}
.small-video > .video-item {
  width: 326px;
  text-align: left;
  border: 1px solid #eaeff5;
  margin-bottom: 89px;
  margin-left: 32px;
  cursor: pointer;
}
.small-video > .video-item > .video {
  background-image: url("../../assets/record-video.png");
  background-size: cover;
  height: 244px;
  position: relative;
}
.small-video > .video-item > .video > .video-cover {
  width: 195px;
  height: 122px;
  position: absolute;
  top: 53px;
  left: 65px;
}

.video-item:first-child {
  margin-left: 0;
}
.video-title {
  font-size: 18px;
  font-weight: 700;
  margin-left: 20px;
  margin-top: 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.video-num {
  margin-top: 12px;
  font-size: 16px;
  font-weight: 400;
  margin-left: 20px;
  margin-bottom: 20px;
}
.line {
  width: calc(100% - 40px);
  height: 1px;
  background: #eaeff5;
  margin: 20px;
}
.item-footer {
  display: flex;
  justify-content: space-between;
  padding: 0 20px 20px 20px;
  color: #999da6;
  line-height: 17px;
  font-size: 12px;
}
.flexbox {
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin: 100px 259px 50px;
  box-sizing: border-box;
}
.f-title {
  font-size: 32px;
  font-weight: 700;
  color: #111111;
}
.f-more {
  font-size: 24px;
  font-weight: 400;
  color: #333333;
  position: absolute;
  right: 0;
  cursor: pointer;
}
</style>
